import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ViewCollections from "../Components/Collections/viewCollections";
import ListCollections from "../Components/Collections/listCollections";
import AddCollections from "../Components/Collections/addCollections";
import AddSubCollections from "../Components/Collections/addSubCollections";
import EditSubCollections from "../Components/Collections/editSubCollections";
import EditCollections from "../Components/Collections/editCollections";

const CollectionRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  return (
    <Routes>
      <Route
        path="/collections"
        element={<ListCollections></ListCollections>}
      />

      <Route
        path="/collections/add"
        element={canAdd ? <AddCollections></AddCollections> : <Navigate to="/collections" replace />}
      />

      <Route
        path="/collections/edit/:id"
        element={canEdit ? <EditCollections></EditCollections> : <Navigate to="/collections" replace />}
      />

      <Route
        path="/collections/view/:id"
        element={<ViewCollections></ViewCollections>}
      ></Route>

      <Route
        path="/collections/:id/sub/add"
        element={<AddSubCollections></AddSubCollections>}
      ></Route>

      <Route
        path="/collections/:id/sub/edit"
        element={<EditSubCollections></EditSubCollections>}
      ></Route>
    </Routes>
  );
};

export default CollectionRoutes;
